"use client"

import dynamic from "next/dynamic"

// T13: secciones de la homepage bajo el fold (marcas, ofertas/banners)
// con código partido y sin SSR. El hero queda SSR e intacto — es el LCP.
// Contenido: imágenes decorativas (Googlebot las ve vía render JS);
// el texto indexable de la homepage (H1, enlaces de categoría del nav,
// productos destacados) sigue en el HTML inicial.
const Banners = dynamic(() => import("@modules/banners"), { ssr: false })
const Brands = dynamic(() => import("@modules/brands"), { ssr: false })

export { Banners, Brands }
